import { render, staticRenderFns } from "./QuickAddProductsDialog.vue?vue&type=template&id=8e3f28d0&scoped=true"
import script from "./QuickAddProductsDialog.ts?vue&type=script&lang=ts&external"
export * from "./QuickAddProductsDialog.ts?vue&type=script&lang=ts&external"
import style0 from "./QuickAddProductsDialog.scss?vue&type=style&index=0&id=8e3f28d0&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e3f28d0",
  null
  
)

export default component.exports